export default __webpack_public_path__ + "static/media/gallery-wip-emitter-cover_04.adaf074f.jpg";